
import { 
	ifAuthenticated, 
	ifNotAuthenticated, 
	ifAuthenticatedOnline, 
	AppTabs,
	Edit,
	Create,
	trans
} from '@/router/index'

import ExtrapolationMails from '@/components/modules/marbec/ExtrapolationMails'
import SoldProducts from '@/components/modules/analytics/SoldProducts'
import SalesTrend from '@/components/modules/analytics/SalesTrend'
import ExpirationProducts from '@/components/modules/marbec/ExpirationProducts'
import RevenueCategories from '@/components/modules/analytics/RevenueCategories'
import CommercialOptions from '@/components/modules/marbec/settings/CommercialOptions'


export const marbec = [

	/**********************************************************************************
	*
	* @COMMERCIAL
	*
	***********************************************************************************/
	{
		path: '/commercial', 
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs, 
		props: {
			tabs: [
				{				
					to: '/commercial/',
					text: 'Estrazione mail',
				},
				{
					to: '/commercial/soldproducts/',
					text: 'Prodotti venduti',
				},			
				{
					to: '/commercial/salestrend/',
					text: 'Fatturato clienti',
				},			
				{
					to: '/commercial/expirationproducts/',
					text: 'Scadenze prodotti',
				},
				{
					to: '/commercial/revenuecategories/',
					text: 'Fatturato',
				},
			],
		},
		children: [	
			{
				path: '/commercial/',
				beforeEnter: ifAuthenticatedOnline,
				component: ExtrapolationMails,
			},
			{
				path: '/commercial/soldproducts/',
				beforeEnter: ifAuthenticatedOnline,
				component: SoldProducts,
				props: {
					url: 'marbecsoldproducts',
				}
			},
			{
				path: '/commercial/salestrend/',
				beforeEnter: ifAuthenticatedOnline,
				component: SalesTrend,
				props: {
					url: 'marbecsalestrend',
				}
			},		
			{
				path: '/commercial/expirationproducts/',
				beforeEnter: ifAuthenticatedOnline,
				component: ExpirationProducts,
			},
			{
				path: '/commercial/revenuecategories/',
				beforeEnter: ifAuthenticatedOnline,
				component: RevenueCategories,
				props: {
					url: 'marbecrevenuecategories',
				}
			},
		],
	},
	{
		path: '/settingscommercial/',
		name: 'settingscommercial',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{				
					to: '/settingscommercial/',
					text: 'Commerciale',
				},
			],
		},
		children: [	
			{
				path: '/settingscommercial/',
				beforeEnter: ifAuthenticatedOnline,
				component: CommercialOptions,
			},
		]
	},
]